/*
 * -----------------------------------------------------------------------
 *  <copyright file="import-errors.tsx" company="Triumph Research Intelligence">
 *      Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import React from 'react';
import { useTranslation } from 'hooks';
import ExpandableGrid from 'views/components/core/expandable/grid';

export const ImportErrors = ({ errors }: any) => {
    const { t } = useTranslation();

    return (
        <>
            <div className="secondary" style={{ fontSize: 14, marginBottom: 20 }}>
                {t('ra:importErrors', { count: errors.length })}
            </div>
            <ExpandableGrid
                customKey="errors-grid"
                id="imported-errors"
                key="imported-errors-grid"
                items={errors}
                groupable={false}
                showPager
                addScroll
                scrollable="scrollable"
                reorderable
                pageable={false}
                resizable
                options={{
                    allowExcelExport: false,
                    allowExpandCollapseAll: false,
                    useFilterChips: false,
                }}
                columns={[
                    {
                        field: 'line',
                        label: t('ra:line'),
                        width: 120,
                    },
                    {
                        field: 'message',
                        label: t('ra:message'),
                        width: 600,
                    },
                ]}
            />
        </>
    );
};

export default ImportErrors;
